var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTagOne(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25488 10.0669C8.25488 9.1004 9.03838 8.31689 10.0049 8.31689H31.0049C31.469 8.31689 31.9141 8.50127 32.2423 8.82946L51.1099 27.6971C53.4169 30.0178 53.4169 33.7659 51.1099 36.0866L51.1063 36.0903L36.05 51.1466C34.934 52.2639 33.4195 52.8916 31.8403 52.8916C30.2615 52.8916 28.7475 52.2642 27.6315 51.1474L8.76814 32.305C8.43952 31.9768 8.25488 31.5314 8.25488 31.0669V10.0669ZM11.7549 11.8169V30.3415L30.1056 48.6717C30.5652 49.1318 31.1901 49.3916 31.8403 49.3916C32.4907 49.3916 33.1142 49.1331 33.5737 48.6731L48.6277 33.6191C49.5759 32.6639 49.5772 31.1212 48.6291 30.1659L30.28 11.8169H11.7549Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2549 25.2336C23.8657 25.2336 25.1716 23.9277 25.1716 22.3169C25.1716 20.7061 23.8657 19.4002 22.2549 19.4002C20.6441 19.4002 19.3382 20.7061 19.3382 22.3169C19.3382 23.9277 20.6441 25.2336 22.2549 25.2336Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagOne);
export default __webpack_public_path__ + "static/media/tag-one.1f4b2302.svg";
export { ForwardRef as ReactComponent };